import * as actionTypes from './actiontype';

export const userInfoAction = (data) => ({
    type: actionTypes.USER_INFO,
    payload: data,
});
export const dispatchUserProgress = (data) => ({
    type: actionTypes.USER_PROGRESS,
    payload: data,
});